import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { getAuth, signOut } from "firebase/auth";
import { loginWithBackend } from "../../auth/signin";
import { gql } from "@apollo/client";

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, extensions, path }) => {
        if (extensions) {
          if (extensions.code === "UNAUTHENTICATED") {
            // For authentication errors, force re-authentication
            const auth = getAuth();
            signOut(auth);
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("auth", "true");
            window.location.href = currentUrl.toString();
          } else if (extensions.code === "GRAPHQL_VALIDATION_FAILED") {
            // For validation errors, re-run the login query
            const auth = getAuth();
            const user = auth.currentUser;
            if (user && user.email) {
              user.getIdToken().then((token) => {
                return forward(operation).map((response) => {
                  // Re-run the login query
                  return loginWithBackend(
                    client,
                    user.email!,
                    user.uid,
                    token
                  ).then(() => response);
                });
              });
            }
          } else {
            console.error(`[GraphQL error]: Message: ${message}`);
            console.error(`[GraphQL error]: Path: ${path?.join(".")}`);
            console.error(`[GraphQL error]: Extensions:`, extensions);
            console.error(
              `[GraphQL error]: Operation:`,
              operation.operationName
            );
          }
        }
      });
    }

    if (networkError) {
      console.error(`[Network error]: ${networkError}`);
      console.error(`[Network error]: Operation:`, operation.operationName);
    }
  }
);

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_SERVER_URL,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
export const client = new ApolloClient({
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache(),
});
